import {
  compose,
  withHandlers,
  withState,
  renameProp,
  lifecycle,
  defaultProps,
} from 'recompose'
import * as R from 'ramda'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

const enhance = compose(
  renameProp('onChange', 'onChangeCallBack'),
  toReduxFormField('InputAutocomplete'),
  defaultProps({
    handleBlur: R.identity,
    handleFocus: R.identity,
    handleKeyDown: R.identity,
  }),
  withState('selectedValue', 'updateSelectedValue', R.prop('selectedValue')),
  withHandlers({
    handleChange:
      ({
        updateSelectedValue,
        onChangeCallBack = R.identity,
        input: { onChange = R.identity } = {},
      }) =>
      option => {
        updateSelectedValue(option)
        onChange(option)
        onChangeCallBack(option)
      },
    handleClearSearch: props => () => {
      props.updateSelectedValue(null)
    },
  }),
  lifecycle({
    componentDidMount() {
      const initialValue =
        parseIfIsReduxInitialValues(this.props.input.value) ||
        this.props.selectedValue

      this.props.updateSelectedValue(initialValue)
      this.props.input.onChange(initialValue)
    },
    componentDidUpdate(prevProps) {
      // Sometimes the values come in as immutable object
      // and we need to handle that
      const currentInputValue = this.props.input.value.toJS
        ? this.props.input.value.toJS()
        : this.props.input.value
      const prevInputValue = prevProps.input.value.toJS
        ? prevProps.input.value.toJS()
        : prevProps.input.value

      const initialValue =
        parseIfIsReduxInitialValues(currentInputValue) ||
        this.props.selectedValue
      const prevInitialValue =
        parseIfIsReduxInitialValues(prevInputValue) || prevProps.selectedValue

      if (
        !(JSON.stringify(prevInitialValue) === JSON.stringify(initialValue))
      ) {
        this.props.updateSelectedValue(initialValue)
      }
      if (
        R.either(R.isEmpty, R.isNil)(currentInputValue) &&
        !R.either(R.isEmpty, R.isNil)(prevInputValue)
      ) {
        // if clearOnReset flag is present, clear value completely rather than
        // returning to its initial value
        if (this.props.clearOnReset) {
          this.props.updateSelectedValue(null)
        } else {
          this.props.updateSelectedValue(initialValue)
        }
      }

      // Currently only used for consumer app doctor search
      // Basically, it clears out the search field of the selectedValue if focused so that only placeholder is shown
      // If we use this method across other places that uses this component, we can refactor to make DRY
      if (
        typeof this.props.isFocused !== 'undefined' &&
        this.props.isFocused &&
        this.props.selectedValue
      ) {
        this.props.updateSelectedValue(null)
      }
    },
  }),
)

export default enhance

const parseIfIsReduxInitialValues = initialValues => {
  if (!!initialValues && initialValues.toJS) {
    return initialValues.toJS()
  } else {
    return initialValues
  }
}
